import { render, staticRenderFns } from "./reply-detail.vue?vue&type=template&id=088375c5&scoped=true&"
import script from "./reply-detail.vue?vue&type=script&lang=js&"
export * from "./reply-detail.vue?vue&type=script&lang=js&"
import style0 from "./reply-detail.vue?vue&type=style&index=0&id=088375c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088375c5",
  null
  
)

export default component.exports